import styled from 'styled-components/macro'

import { Title as TitleBase } from 'components/misc'
import { mq } from 'styles/mq'
import { Thread } from 'styles/misc'

export const Title = styled(TitleBase)`
  margin-top: 3rem;
  width: 100%;
  ${mq.smallOnly} {
    margin-top: 8rem;
  }

  &::before {
    ${Thread}
    left: 0;
    top: 40%;
    ${mq.smallOnly} {
      top: -5rem;
    }
    width: 100%;
    height: auto;
    aspect-ratio: 390 / 36;
    clip-path: none;
    mask-image: url("data:image/svg+xml,%3Csvg width='390' height='36' viewBox='0 0 390 36' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M-113.846 2.37042C-104.725 9.00292 -93.4597 11.1778 -82.5458 13.0227C38.7708 33.5478 162.652 32.9874 284.921 20.3733C292.9 19.5501 303.339 15.6851 302.482 7.21051C301.689 -0.621792 289.737 -2.13687 285.591 4.39053C281.445 10.9179 284.501 20.3909 290.322 25.2631C296.142 30.1353 303.839 31.5073 311.2 32.386C326.078 34.1609 341.07 34.5871 356.039 34.9111C439.364 36.7181 522.746 35.4599 605.989 31.1336' stroke='black' vector-effect='non-scaling-stroke' stroke-miterlimit='10'/%3E%3C/svg%3E%0A");
  }

  ${mq.medium} {
    margin-top: 13rem;
    width: auto;

    &::before {
      transform: translate(-50%, 18%);
      aspect-ratio: 2112 / 561;
      mask-image: url("data:image/svg+xml,%3Csvg width='2112' height='561' viewBox='0 0 2112 561' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M0.25 76.45C77.2 31.78 228.66 -19.87 255.2 8.72998C297.52 54.32 56.23 143.28 43.93 253.25C43.19 259.88 43.28 267.2 47.42 272.44C54.14 280.94 67.19 279.52 77.79 277.24C318.91 225.45 558 152.22 804.53 145.86C820.75 145.44 837.63 145.45 852.28 152.42C866.93 159.39 878.57 175.42 875.16 191.28C873.12 200.78 866.3 208.42 859.73 215.58C834.32 243.3 808.9 271.02 783.49 298.74C769.82 313.65 755.38 335.2 766.35 352.19C774.84 365.34 793.37 366.43 809 365.59C968.12 357.01 1123.62 295.08 1282.38 308.71C1300.9 310.3 1320.05 313.18 1335.51 323.5C1350.97 333.82 1361.62 353.5 1356.06 371.24C1352.64 382.14 1343.98 390.43 1336.01 398.62C1299.98 435.62 1272.73 497.61 1307.36 535.93C1324.51 554.91 1352.03 560.99 1377.59 560.28C1426.06 558.94 1471.32 537.39 1515.67 517.78C1702.99 434.92 1915.63 379.51 2111.84 438.28' stroke='black' stroke-width='1.5' vector-effect='non-scaling-stroke' stroke-miterlimit='10'/%3E%3C/svg%3E%0A");
    }
  }
`

export const Figure = styled.figure`
  position: relative;
  margin: 0;
`
